import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { exportFormattedExcelReport } from '../../utils/formattedExcelExport';
import { MARKETING_REPORT_SECTIONS, formatMarketingReportCell } from './marketingPersonReportSections';

const EXISTING_CUSTOMER_COLUMNS = [
  { key: 'metric', label: 'Description' },
  { key: 'count', label: 'Count', align: 'end' },
];

export async function exportMarketingPersonReportExcel({
  filename,
  reportDetails,
  documentTitle = 'Marketing Person Report',
  header,
  infoLines,
}) {
  const workbook = new ExcelJS.Workbook();

  for (const section of MARKETING_REPORT_SECTIONS) {
    const worksheet = workbook.addWorksheet(section.tabLabel.slice(0, 31));

    if (section.type === 'count') {
      await exportFormattedExcelReport({
        filename: 'temp',
        documentTitle: section.title,
        infoLines,
        columns: EXISTING_CUSTOMER_COLUMNS,
        rows: [{
          metric: 'Existing Customers',
          count: Number(reportDetails.existing_customer_count || 0),
        }],
        formatCellValue: (value, key) => (
          key === 'count' && Number.isFinite(Number(value))
            ? Number(value).toFixed(0)
            : value
        ),
        totalKeys: ['count'],
        header,
        workbook,
        worksheet,
      });
      continue;
    }

    const rows = reportDetails[section.key] || [];
    await exportFormattedExcelReport({
      filename: 'temp',
      documentTitle: section.title,
      infoLines,
      columns: section.columns.map((column) => ({
        key: column.key,
        label: column.label,
        align: column.align,
      })),
      rows,
      formatCellValue: formatMarketingReportCell,
      totalKeys: section.totalKeys || [],
      header,
      workbook,
      worksheet,
    });
  }

  const buffer = await workbook.xlsx.writeBuffer();
  const safeFilename = filename.endsWith('.xlsx') ? filename : `${filename}.xlsx`;
  saveAs(
    new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
    safeFilename,
  );
}
